import React from 'react';
import { useNavigate } from 'react-router-dom';
import { preferencesGroupsService } from '../../services/preferencesGroupsService';
import { useTranslation } from 'react-i18next';

const formatDateValue = (date) => {
    if(date) {
        return date.split('T')[0].split('-').slice(1).reverse().join('.');
    } 
    return '';
};

const PreferenceGroupsListItemContent = ({ group }) => {
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const name = preferencesGroupsService.getLocalization(i18n.resolvedLanguage, group, false);
    return (
        <div className='preference__groups'>
            <button
                type="button"
                className="preference__groups-name cursor-pointer border-0 bg-transparent p-0 text-left font-inherit hover:underline"
                onClick={() => navigate(`/preference/group/${group.id}`)}
            >
                {name}
            </button>
            <ul className='preference__groups-list'>
                {group.activityPeriods && group.activityPeriods.length ?
                    group.activityPeriods.map((it, index) => (
                        <li className='preference__groups-period' key={it.dateStart + it.dateStop + index}>
                            {formatDateValue(it.dateStart)} - {formatDateValue(it.dateStop)}
                        </li> 
                    ))
                    :
                    <li className='preference__groups-period'>
                        {i18n.t('app.page.preference.groups.always')}
                    </li>}
            </ul>
        </div>
    );
};

export default PreferenceGroupsListItemContent;
